module.exports = __webpack_public_path__ + "img/art-work-icon6.7def80b8.png";